import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FeedService } from '../../../services/feed.service';

@Component({
  selector: 'app-home-instagram-section',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './home-instagram-section.component.html',
})
export class HomeInstagramSectionComponent {
  constructor(public feed: FeedService) {}
}
